import React from 'react';
import './index.scss';

class NewUserRedpackDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
    };
  }

  componentDidMount() {
  }

  render() {
    return (
			<div className="redpackDialog">
				<div className="redpack">
					<div className="redpackGet">
						<div className="tip">
							<div className="desc">恭喜你获得<span className="num">20</span>元现金红包</div>
							<div className="desc">连续签到7天可得</div>
						</div>
						{this.state.login
						  ? <div className="withdraw">立即提现</div>
						  :							<div className="withdraw login">登录后立即签到</div>
						}
					</div>
					<div className="close"></div>
				</div>
			</div>
    );
  }
}

export default NewUserRedpackDialog;
